export enum DsSmileStaticFaceType {
    DefaultSmile = "default-smile",
    BigSmile = "big-smile",
    SmileClosedEyes = "smile-closed-eyes",
    BigSmileClosedEyes = "big-smile-closed-eyes",
    Sleeping = "sleeping",
    Tongue = "tongue",
    Blink = "blink",
    Lol = "lol",
    Pogo = "pogo",
    Amazed = "amazed",
    AmazedEyebrow = "amazed-eyebrow",
    Sad = "sad",
    SadClosedEyes = "sad-closed-eyes",
    Sick = "sick",
    Hesitant = "hesitant",
    Puffy = "puffy",
    Hearts = "hearts",
    Stars = "stars",
}

export enum DsSmileStaticFacePosition {
    Center = "center",
    CenterTop = "center-up",
    CenterDown = "center-down",
    LeftUp = "left-up",
    LeftDown = "left-down",
    RightUp = "right-up",
    RightDown = "right-down",
}
